import { AuthService, ConfigStateService } from '@abp/ng.core';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { PaymentTypeDto } from '@proxy/payment-types';
import { AddMemberVM, MemberInfo, PaymentCreateDto, PaymentDto } from '@proxy/payments';
import { MemberInfoDto, PublicService } from '@proxy/public';

import { DialogService } from 'primeng/dynamicdialog';
import { MembershipFormComponent } from '../membership-form/membership-form.component';
import { PublicDownloadService } from '../services/public-download.service';
import { UserInfoDto } from '@proxy/shared';
import { AddMemberInfo, MembershipInfo } from '../shared/membership-application.model';
import { SettingsService } from '@proxy/settings';
import { ActivatedRoute } from '@angular/router';
import { StripeService } from '@proxy/stripe';
import { CustomerSubscriptionsResponse, StripeSubscriptionDto } from '@proxy/stripe/dtos';
import { ToasterService } from '@abp/ng.theme.shared';
import * as moment from 'moment';
import { IdentityUserDto } from '@volo/abp.ng.identity/proxy';

@Component({
  selector: 'app-receipts',
  templateUrl: './receipts.component.html',
  styleUrls: ['./receipts.component.scss'],
  providers:[DialogService]

})
export class ReceiptsComponent implements OnInit{
  currentUser$ = this.configState.getDeep$('currentUser');
  currentUser: any;
  activeUserId: string;

  memberInfo: MemberInfoDto={} as MemberInfoDto;
  membershipPayments:PaymentDto[]=[];
  currentYear:number=2024;
  paymentHandler: any = null;
  familyMembers:IdentityUserDto[]=[];
  currentUserInfo: UserInfoDto;
  displayMessage:boolean=false;
  messageContent:string='';
  uiBusy:boolean=false;
  previousYears: number[] = [];
  
  // Subscription-related properties
  customerSubscriptions: CustomerSubscriptionsResponse | null = null;
  subscriptionsLoading: boolean = false;
  showSubscriptions: boolean = false;
  
  constructor(
    private authService: AuthService,
    private configState: ConfigStateService,
    private publicService: PublicService,
    private dialogService: DialogService,
    private downloadService: PublicDownloadService,
    private settingService: SettingsService,
    private activatedRoute: ActivatedRoute,
    private stripeService: StripeService,
    protected toaster: ToasterService
  ){

  }

  get hasLoggedIn(): boolean {
    return this.authService.isAuthenticated
  }

  login() {
    this.authService.navigateToLogin({
      returnUrl : '/membership'
    } );
  }

  hasCurrentYearMembership(){
    return this.membershipPayments.filter(p => p.accountingYear == this.currentYear).length;
    
  }
  ngOnInit(): void {
    const currentYear = new Date().getFullYear();
    this.previousYears = Array.from({length: 5}, (_, i) => currentYear - (i + 1));

    this.currentUser$.subscribe(val => {
      this.currentUser = val;
      this.activeUserId = this.currentUser.id;
      if(this.hasLoggedIn){
        if(this.currentUser 
          && this.currentUser.roles
          && this.currentUser.roles.length
          && this.currentUser.roles.indexOf("admin") > -1){
            this.activatedRoute.params.subscribe(p => {
              if(p.id){
                this.activeUserId = p.id.toLowerCase();
                this.loadData(p.id);
  
              }
              else{
                this.loadData(this.activeUserId);
              }
            })
          }
          else{
            this.loadData(this.activeUserId);
          }
      }
      

    });
    this.settingService.getSettingsByNames("Mandir.CurrentAccountYear").subscribe(
      setting => {
        if(setting.length){
          this.currentYear = parseInt(setting[0].value);

        }
      })
    
    
    
    
  }

  loadData(userId){
    
    this.publicService.getUserInfoById(userId).subscribe(data => {
      
      this.currentUserInfo = data;
      this.loadSubscriptions();
    });

    this.publicService.getMemberInfoByUserId(userId).subscribe(data => {
      
      this.memberInfo = data;
      this.familyMembers = data.familyMembers;
      var membershipCategories = data.paymentTypes.filter(m => m.name =="Membership Fee" || m.name.indexOf("Membership") > -1 || m.name == "NR Membership").map(c => c.id);
      if(membershipCategories.length){
        this.membershipPayments = data.payments.filter(p=> membershipCategories.indexOf(p.paymentTypeId) > -1);
      }
      

    });
  }
  

  getAnnualReceipt(id, year){
    this.uiBusy=true;
    
    this.downloadService.getAnnualReceiptByHtml(id+":" + this.activeUserId, year).subscribe(newBlob=>{
      
    const data = window.URL.createObjectURL(newBlob);

    var link = document.createElement('a'); 
    link.href = data;
    link.download = "VaishnoDevi-Mandir-Annual-Receipt-"+year+".pdf";
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    this.uiBusy=false;
  
    })
  }

  getPaymentType(id:string){
    var types = this.memberInfo.paymentTypes.filter(t => t.id == id);
    if(!types.length)
      return '';

      return types[0].name;
  }


  

  getPaymentsByUser(membershipPayments, userId){
    return membershipPayments.filter(p => p.payeeId == userId);
  }

  getReceipt(id){
    this.uiBusy = true;
    this.downloadService.getReceiptByHtml(id).subscribe(newBlob=>{
      
      //var newBlob = new Blob([x as any], { type: "application/pdf" });
    console.log(newBlob);
    const data = window.URL.createObjectURL(newBlob);

    var link = document.createElement('a'); 
    link.href = data;
    link.download = "VaishnoDevi-Mandir-Receipt_"+id+".pdf";
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      this.uiBusy = false;
    });

  }

  showReceipt(id){
    this.uiBusy = true;
    this.publicService.getReceiptDetailsById(id).subscribe(newBlob=>{
      
      //var newBlob = new Blob([x as any], { type: "application/pdf" });
    console.log(newBlob);
    this.uiBusy = false;
   

  })
}

  // Subscription-related methods
  loadCustomerSubscriptions() {
    if (!this.currentUserInfo?.email) {
      this.toaster.error('User email not found');
      return;
    }

    this.subscriptionsLoading = true;
    this.stripeService.getCustomerSubscriptions(this.currentUserInfo.email)
      .subscribe({
        next: (response) => {
          this.customerSubscriptions = response;
          this.subscriptionsLoading = false;
        },
        error: (error) => {
          console.error('Error loading subscriptions:', error);
          this.subscriptionsLoading = false;
          this.toaster.error('Failed to load subscriptions');
        }
      });
  }

  loadSubscriptions() {
    this.showSubscriptions = !this.showSubscriptions;
    if (this.showSubscriptions && !this.customerSubscriptions) {
      this.loadCustomerSubscriptions();
    }
  }

  openBillingPortal(customerId?: string) {
    if (!this.currentUserInfo?.email) {
      this.toaster.error('User email not found');
      return;
    }

    const returnUrl = window.location.origin + '/receipts';
    
    this.uiBusy = true;
    this.stripeService.createCustomerBillingPortalSessionByCustomerIdAndReturnUrl(
      customerId || '', 
      returnUrl
    ).subscribe({
      next: (portalUrl) => {
        this.uiBusy = false;
        // Open Stripe billing portal in a new tab
        window.open(portalUrl, '_blank');
      },
      error: (error) => {
        console.error('Error creating billing portal session:', error);
        this.uiBusy = false;
        this.toaster.error('Failed to open billing portal');
      }
    });
  }

  getSubscriptionStatusBadgeClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'badge bg-success';
      case 'canceled':
      case 'cancelled':
        return 'badge bg-danger';
      case 'past_due':
        return 'badge bg-warning';
      case 'incomplete':
        return 'badge bg-secondary';
      default:
        return 'badge bg-secondary';
    }
  }

  formatSubscriptionAmount(subscription: StripeSubscriptionDto): string {
    const amount = subscription.amount?.toFixed(2) || '0.00';
    const currency = subscription.currency?.toUpperCase() || 'CAD';
    const interval = subscription.interval || 'month';
    const intervalCount = subscription.intervalCount || '1';
    
    const intervalText = intervalCount === '1' ? interval : `${intervalCount} ${interval}s`;
    return `$${amount} ${currency} / ${intervalText}`;
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    return moment(dateString).format('MMM DD, YYYY');
  }
}
